import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Users, History } from "lucide-react";
import { ListMembersContent } from "./ListMembersContent";
import { ListHistoryTab } from "./ListHistoryTab";
import { List } from "@/types/list";
import { useTranslation } from "react-i18next";

interface ListTabsProps {
  list: List;
  members: any[];
  isLoadingMembers: boolean;
  onMembersChange: () => void;
  onAddCandidates?: () => void;
  onAISearch?: () => void;
  refetchList?: () => Promise<void>;
  activeTab: string;
  setActiveTab: (tab: string) => void;
}

export const ListTabs = ({
  list,
  members,
  isLoadingMembers,
  onMembersChange,
  onAddCandidates,
  onAISearch,
  refetchList,
  activeTab,
  setActiveTab
}: ListTabsProps) => {
  const { t } = useTranslation();

  return (
    <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
      <TabsList className="w-full mb-4 flex flex-wrap gap-x-2 gap-y-2 bg-gray-100 dark:bg-gray-800 rounded-sm p-2">
        <TabsTrigger value="members" className="flex-shrink-0 flex items-center gap-2 min-w-max">
          <Users className="h-4 w-4" />
          <span>{t("lists.tabs.members", "Members")}</span>
        </TabsTrigger>
        <TabsTrigger value="history" className="flex-shrink-0 flex items-center gap-2 min-w-max">
          <History className="h-4 w-4" />
          <span>{t("lists.tabs.history", "History")}</span>
        </TabsTrigger>
      </TabsList>
      
      <TabsContent value="members" className="bg-white dark:bg-gray-900 rounded-sm shadow p-6">
        <ListMembersContent
          members={members}
          isLoading={isLoadingMembers}
          listId={list.id}
          listName={list.name}
          onMembersChange={onMembersChange}
          onAddCandidates={onAddCandidates}
          onAISearch={onAISearch}
        />
      </TabsContent>
      
      <TabsContent value="history" className="bg-white dark:bg-gray-900 rounded-sm shadow p-6">
        <ListHistoryTab listId={list.id} />
      </TabsContent>
    </Tabs>
  );
};
